// imports
import { FC, memo } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';

// components
import { BackdropLoader } from './BackdropLoader';

// interfaces, constants
import { LoadingButtonProps } from 'interfaces';
import { flexCenter } from 'theme/styleConstant';

export const LoadingButton: FC<LoadingButtonProps> = memo(
  ({
    children,
    loading = false,
    disabled,
    loadingSize = 32,
    startIcon,
    endIcon,
    text,
    loadingText,
    variant = 'contained',
    type = 'submit',
    appLoader = false,
    ...props
  }) => {
    const spinner = (
      <CircularProgress
        size={loadingSize}
        color="inherit"
        aria-label="loading"
        sx={{ mr: loadingText ? 1 : 0, p: 1 }}
      />
    );

    return (
      <Button
        {...props}
        disabled={disabled || loading}
        startIcon={!loading && startIcon}
        endIcon={!loading && endIcon}
        variant={variant}
        type={type}>
        <Box {...flexCenter}>
          {appLoader ? <BackdropLoader open={loading} text={loadingText} /> : loading && spinner}
          {!appLoader && loading ? loadingText : text}
        </Box>
      </Button>
    );
  },
);
